<template>
    <CardBase :app="app" :card="card" ref="card">

        <template #title>
            <slot name="title"></slot>
        </template>

        <template v-if="$slots.status" #status>
            <slot name="status"></slot>
        </template>

        <template #content>

            <transition name="fade">
                <div v-if="$slots.pre" class="card-generate-optional pre">
                    <slot name="pre"></slot>
                </div>
            </transition>

            <div class="card-generate-options">
                <slot name="options"></slot>
            </div>

            <transition name="fade">
                <div v-if="$slots.post" class="card-generate-optional post">
                    <slot name="post"></slot>
                </div>
            </transition>
            
        </template>

        <template v-if="$slots.side" #side>
            <slot name="side"></slot>
        </template>

    </CardBase>
</template>

<script>
import CardBase from '@/components/flow/cards/CardBase.vue'

export default {
    name: 'CardGenerate',
    components: {
        CardBase
    },
    props: {
        app: {
            type: String,
            required: true
        },
        card: {
            type: Object,
            required: true
        }
    },
    methods: {
        reset() {
			this.$refs.card?.reset()
		},
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}

.card-generate-options {
    flex-shrink: 1;
    width: 100%;
    display: flex;
    flex-wrap: wrap; 
    flex-direction: row;
    align-items: center;
    align-content: center;
    justify-content: center;
    gap: 50px;
    padding-top: 50px;
    padding-bottom: 50px;
}

.card-generate-optional {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 1.3rem;
}

.card-generate-optional.pre {
    width: 100%;
    align-items: flex-end;
}

.card-generate-optional.post {
    width: 100%;
    align-items: flex-start;
}

@media (max-width: 2000px) {
    .card-generate-options {
        gap: 40px;
        padding-top: 40px;
        padding-bottom: 40px;
    }
}

@media (max-width: 1600px) {
    .card-generate-options {
        gap: 25px;
        padding-top: 25px;
        padding-bottom: 25px;
    }

    .card-generate-optional {
        font-size: 1.2rem;
    }
}

@media (max-width: 1200px) {
    .card-generate-options {
        gap: 15px;
        padding-top: 15px;
        padding-bottom: 15px;
    }
}

@media (max-height: 1000px) {
    .card-generate-options {
        gap: 15px;
        padding-top: 15px;
        padding-bottom: 15px;
    }
}

@media (max-width: 800px) {
    .card-generate-options {
        flex-shrink: unset;
        flex-grow: 1;
    }

    .card-generate-optional {
        font-size: 1.1rem;
    }
}

@media (max-width: 600px) {
    .card-generate-optional {
        font-size: 1.0rem;
    }
}
</style>